// import React, { useState } from "react";
// import Widget from "Components/Common/Widget/Widget";
// import { GiMoneyStack } from "react-icons/gi";
// import { TbSquareRoundedCheck, TbSquareRoundedX } from "react-icons/tb";
// import RequestedUsersTable from "../../../Components/WithdrawalRequest/RequestedUsersTable";
// import AvailableGiftBalanceTable from "Components/WithdrawalRequest/AvailableGiftBalanceTable";
// import ConversionTable from "Components/WithdrawalRequest/ConversionTable";

// const WithdrawalRequest = () => {
//   const [activeTab, setActiveTab] = useState("requests"); // 'requests' or 'balance'
//   const [statistics, setStatistics] = useState({
//     total: 0,
//     approved: 0,
//     pending: 0,
//   });

//   return (
//     <React.Fragment>
//       <div className="mb-4 flex border-b">
//         <button
//           className={`px-4 py-2 text-sm font-medium ${
//             activeTab === "requests"
//               ? "border-b-2 border-[#c51369] text-[#c51369]"
//               : "text-gray-500"
//           }`}
//           onClick={() => setActiveTab("requests")}
//         >
//           Withdrawal Requests
//         </button>
//         <button
//           className={`px-4 py-2 text-sm font-medium ${
//             activeTab === "balance"
//               ? "border-b-2 border-[#c51369] text-[#c51369]"
//               : "text-gray-500"
//           }`}
//           onClick={() => setActiveTab("balance")}
//         >
//           Available Balance
//         </button>
//         <button
//           className={`px-4 py-2 text-sm font-medium ${
//             activeTab === "conversion"
//               ? "border-b-2 border-[#c51369] text-[#c51369]"
//               : "text-gray-500"
//           }`}
//           onClick={() => setActiveTab("conversion")}
//         >
//           Conversion Rate
//         </button>
//       </div>

//       {activeTab === "requests" ? (
//         <>
//           <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
//             <Widget
//               icon={<GiMoneyStack className="h-6 w-6" />}
//               title={"Total Requests Raised"}
//               subtitle={statistics.total}
//             />
//             <Widget
//               icon={<TbSquareRoundedCheck className="h-6 w-6" />}
//               title={"Total Approved Requests"}
//               subtitle={statistics.approved}
//             />
//             <Widget
//               icon={<TbSquareRoundedX className="h-6 w-6" />}
//               title={"Total Pending Requests"}
//               subtitle={statistics.pending}
//             />
//           </div>
//           <RequestedUsersTable setStatistics={setStatistics} />
//         </>
//       ) : activeTab === "balance" ? (
//         <AvailableGiftBalanceTable />
//       ) : (
//         <ConversionTable />
//       )}
      

      
//     </React.Fragment>
//   );
// };

// export default WithdrawalRequest;


// ==================================only AvailableGiftBalanceTable & ConversionTable activated=========================================



import React, { useState } from "react";
import Widget from "Components/Common/Widget/Widget";
import { GiMoneyStack } from "react-icons/gi";
import { TbSquareRoundedCheck, TbSquareRoundedX } from "react-icons/tb";
// import RequestedUsersTable from "../../../Components/WithdrawalRequest/RequestedUsersTable";
import AvailableGiftBalanceTable from "Components/WithdrawalRequest/AvailableGiftBalanceTable";
import ConversionTable from "Components/WithdrawalRequest/ConversionTable";

const WithdrawalRequest = () => {
  const [activeTab, setActiveTab] = useState("balance"); // default to balance tab
  const [statistics, setStatistics] = useState({
    total: 0,
    approved: 0,
    pending: 0,
  });

  return (
    <React.Fragment>
      <div className="mb-4 flex border-b">

        <button
          className={`px-4 py-2 text-sm font-medium ${
            activeTab === "balance"
              ? "border-b-2 border-[#c51369] text-[#c51369]"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("balance")}
        >
          Available Balance
        </button>
        <button
          className={`px-4 py-2 text-sm font-medium ${
            activeTab === "conversion"
              ? "border-b-2 border-[#c51369] text-[#c51369]"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("conversion")}
        >
          Conversion Rate
        </button>
      </div>

      {activeTab === "balance" ? (
        <AvailableGiftBalanceTable />
      ) : (
        <ConversionTable />
      )}
    </React.Fragment>
  );
};

export default WithdrawalRequest;
